import { fetch } from '../../utils'
import https from 'https'

const env = process.env
const HOSTNAME = env.REACT_APP_NODE_ENV === 'production'? env.REACT_APP_API_PRODUCTION : env.REACT_APP_API_STAGING

export const login = (input) => {
  const query = `mutation { getToken(email: "${input.email}", password: "${input.password}") }`
  return fetch(HOSTNAME, {
    method: 'POST',
    agent: new https.Agent({ rejectUnauthorized: false }),
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
  .then((res) => {
    return res.json()
  })
  .then((payload) => {
    return payload
  }).catch((error) => {
    throw error
  })
}

export const signIn = (input) => {
  const query = `mutation { createAccount(email: "${input.email}", password: "${input.password}") }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
  .then((res) => {
    return res.json()
  })
  .then((payload) => {
    return payload
  }).catch((error) => {
    throw error
  })
}

export const fetchUser = (payload) => {
  const query = `{ user { email rooms { id covers { id } }}}`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
  .then((res) => {
    return res.json()
  })
  .then((payload) => {
    return payload
  }).catch((error) => {
    throw error
  })
}

export const deleteAccount = data => {
  const query = `mutation{ deleteAccount }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      localStorage.clear()
      return payload
    })
    .catch(error => {
      throw error
    })
}

export const forgotPassword = data => {
  const query = `mutation{ resetPassword(email: "${data.email}") }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      return payload
    })
    .catch(error => {
      throw error
    })
}

export const resetPassword = data => {
  const query = `mutation{newPassword(password: "${data.password}",token:"${data.token}") }`
  return fetch(HOSTNAME, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ query })
  })
    .then(res => {
      return res.json()
    })
    .then(payload => {
      return payload
    })
    .catch(error => {
      throw error
    })
}




// WEBPACK FOOTER //
// ./src/store/user/api.js